// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page_generalContent__YhgbH {
  background: #fff;
  padding: 32px;
  border-radius: 8px;
  width: 100%;
  max-width: 640px;
}

.page_generalRow__N9uGO {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

.page_formControltems__bef7g {
  width: 100%;
}

.page_formControlInputs__Phed4 {
  display: flex;
  gap: 24px;
}

.page_formControlFull__ccYOv {
  width: 100%;
}

.page_formControlFields__Vr-W\\+ {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.page_fieldsLabel__U2mt4 {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 6px;
  color: #111827;
}

/* Input fields */
.page_inputFields__SeiMp {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
}

.page_inputFieldsIcon__gMykn {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
}

.page_inputFieldsIcon__gMykn img {
  width: 18px;
  height: 18px;
}

.page_userEmail__A3fPa img {
  width: 18px;
}

/* Profile section */
.page_profilePictureItems__w0-9X {
  display: flex;
  align-items: center;
  gap: 20px;
}

.page_avatarUpload__57j7u {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  overflow: hidden;
}

.page_profileImagePreview__w-yrE {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

.page_newPageRightRow__6gg4A {
  cursor: pointer;
}

.page_profileImageText__CRQ7K {
  font-size: 14px;
  line-height: 20px;
  color: #374151;
}

.page_uploadBtn__6pinA {
    background: transparent;
    border-radius: 6px;
    padding: 4px 12px;
    font-size: 13px;
    border: 1px solid #d1d5db;
    cursor: pointer;
    box-shadow: 0 1px 3px #0000001a;
    margin-top: 5px;
}

/* Save Button */
.page_saveButton__bn1Xp {
  background: #111827;
  color: #fff;
  padding: 10px 18px;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  border: none;
  margin-top: 20px;
  width: 139px;
  height: 39px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Setting/page.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,+BAA+B;IAC/B,eAAe;AACnB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd","sourcesContent":[".generalContent {\n  background: #fff;\n  padding: 32px;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 640px;\n}\n\n.generalRow {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 15px;\n}\n\n.formControltems {\n  width: 100%;\n}\n\n.formControlInputs {\n  display: flex;\n  gap: 24px;\n}\n\n.formControlFull {\n  width: 100%;\n}\n\n.formControlFields {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.fieldsLabel {\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 6px;\n  color: #111827;\n}\n\n/* Input fields */\n.inputFields {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  outline: none;\n}\n\n.inputFieldsIcon {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 6px;\n}\n\n.inputFieldsIcon img {\n  width: 18px;\n  height: 18px;\n}\n\n.userEmail img {\n  width: 18px;\n}\n\n/* Profile section */\n.profilePictureItems {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.avatarUpload {\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  overflow: hidden;\n}\n\n.profileImagePreview {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  cursor: pointer;\n}\n\n.newPageRightRow {\n  cursor: pointer;\n}\n\n.profileImageText {\n  font-size: 14px;\n  line-height: 20px;\n  color: #374151;\n}\n\n.uploadBtn {\n    background: transparent;\n    border-radius: 6px;\n    padding: 4px 12px;\n    font-size: 13px;\n    border: 1px solid #d1d5db;\n    cursor: pointer;\n    box-shadow: 0 1px 3px #0000001a;\n    margin-top: 5px;\n}\n\n/* Save Button */\n.saveButton {\n  background: #111827;\n  color: #fff;\n  padding: 10px 18px;\n  font-size: 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  border: none;\n  margin-top: 20px;\n  width: 139px;\n  height: 39px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"generalContent": `page_generalContent__YhgbH`,
	"generalRow": `page_generalRow__N9uGO`,
	"formControltems": `page_formControltems__bef7g`,
	"formControlInputs": `page_formControlInputs__Phed4`,
	"formControlFull": `page_formControlFull__ccYOv`,
	"formControlFields": `page_formControlFields__Vr-W+`,
	"fieldsLabel": `page_fieldsLabel__U2mt4`,
	"inputFields": `page_inputFields__SeiMp`,
	"inputFieldsIcon": `page_inputFieldsIcon__gMykn`,
	"userEmail": `page_userEmail__A3fPa`,
	"profilePictureItems": `page_profilePictureItems__w0-9X`,
	"avatarUpload": `page_avatarUpload__57j7u`,
	"profileImagePreview": `page_profileImagePreview__w-yrE`,
	"newPageRightRow": `page_newPageRightRow__6gg4A`,
	"profileImageText": `page_profileImageText__CRQ7K`,
	"uploadBtn": `page_uploadBtn__6pinA`,
	"saveButton": `page_saveButton__bn1Xp`
};
export default ___CSS_LOADER_EXPORT___;
